import axios from 'axios';
export default {
	state: {
		users: [],
		messages: [],
	},
	getters: {
		usersList(state) {
			return state.users;
		},
		getMessages(state) {
			return state.messages;
		},
	},
	mutations: {
		getMessages(state, messages) {
			state.messages = messages;
		},
		getChatRoomUsers(state, users) {
			state.users = users;
		},
	},
	actions: {
		openSocket({commit}, roomName) {
			axios.get(`chat/messages/${roomName}/`).then((response) => {
				let data = response.data;
				commit('getMessages', data);
			});
		},
		getChatRoomUsers(context) {
			return axios
				.get('chat/users/')
				.then((response) => {
					this.users = response.data;
					context.commit('getChatRoomUsers', response.data);
				})
				.catch((error) => {
					console.log(error);
				});
		},
	},
};
